export default __webpack_public_path__ + "static/media/833.27fb1a32.gif";